import React, { useState, useEffect } from "react";
import { Container, Row, Button } from "react-bootstrap";
import { Document, Page, pdfjs } from "react-pdf";
import { AiOutlineDownload } from "react-icons/ai";
import Particle from "../Particle";
import "./Resume.css";                   

pdfjs.GlobalWorkerOptions.workerSrc =
  `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Resume = () => {
  const [pageWidth, setPageWidth] = useState(
    Math.min(window.innerWidth - 32, 900)
  );
  const [numPages, setNumPages] = useState(null);

  useEffect(() => {
    const onResize = () =>
      setPageWidth(Math.min(window.innerWidth - 32, 900));
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const cvUrl = "/Curriculum.pdf";

  return (
    <Container fluid className="resume-section">
      <Particle />

      <Row className="justify-content-center mb-3">
        <Button variant="primary" href={cvUrl} target="_blank" style={{ maxWidth: 250 }}>
          <AiOutlineDownload /> Descargar CV
        </Button>
      </Row>

      <Row className="resume justify-content-center">
        <Document
          file={cvUrl}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          onLoadError={console.error}
        >
          {Array.from({ length: numPages || 0 }, (_, i) => (
            <Page
              key={`page_${i + 1}`}
              pageNumber={i + 1}
              width={pageWidth}
              className="pdf-page"
            />
          ))}
        </Document>
      </Row>
    </Container>
  );
};

export default Resume;
